var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.164 4.184C8.267 3.131 10.075 2.1 12 2.1c1.923 0 3.774 1.07 4.835 2.084l.434.414.83-.867-.434-.415C16.459 2.164 14.326.9 12 .9 9.675.9 7.585 2.123 6.336 3.316l-.434.415.828.867.434-.414ZM12 5.925c-1.232 0-2.091.665-2.574 1.151l-.424.426-.85-.846.423-.426c.582-.586 1.731-1.505 3.425-1.505 1.688 0 2.813.866 3.433 1.513l.415.433-.866.83-.415-.433c-.495-.516-1.328-1.143-2.567-1.143ZM12.6 9a.6.6 0 1 0-1.2 0v9.052l-3.15-3.15-.849.848L12 20.349l4.599-4.599-.849-.848-3.15 3.15V9Zm-9 12v-9.6H2.4V21c0 1.16.94 2.1 2.1 2.1h15a2.1 2.1 0 0 0 2.1-2.1v-9.6h-1.2V21a.9.9 0 0 1-.9.9h-15a.9.9 0 0 1-.9-.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteDownload);
export default __webpack_public_path__ + "static/media/remote_download.6207983315d3dbb2f44173644a4e4255.svg";
export { ForwardRef as ReactComponent };